<template>
    <b-form class="pt-3">
        <b-row>
            <b-form-group label="Progresso" class="col-12 container-input-progress">
                <div class="d-flex col-input-buttons">
                    <b-button 
                        class="btn-input-progress d-flex justify-content-center align-items-center" 
                        @click="decrementPercentage" 
                    >
                        <MinusIcon />                       
                    </b-button>
                    <div class="w-100 mx-1 container-input-field-progress input position-relative">     
                        <div class="input-div d-flex justify-content-center align-items-center " >
                            <span v-if="inputProgress">
                                {{inputProgress}}%
                            </span>
                            <span v-else>
                                0%
                            </span>
                        </div>
                        <b-form-input
                            class="input-field-progress text-center"
                            type="number"
                            inputmode="numeric"
                            placeholder="0%"
                            name="progress"
                            :value="inputProgress"
                            @keydown="filterInput($event)"
                            @input="checkInput($event)"
                            :key="`input-progress-${this.keyRenderInput}`"
                            @click="atualizaEventClick"
                            
                        />
                    </div>
                    
                    <div>
                        <b-button 
                            class="btn-input-progress d-flex justify-content-center align-items-center" 
                            @click="incrementPercentage"
                        > 
                            <PlusIcon />
                        </b-button>
                    </div>
                    
                </div>
                <div class="d-flex buttons-plus">
                    <div class="block-invisible d-none d-sm-block"/>
                    <div class="w-100 mx-0 mx-sm-1 container-input-field-progress buttons ">
                        <b-col class="d-flex px-0 container-btns-add-percentage">
                            <b-button 
                                class="container btn-add-percentage ml-0"
                                @click="addPercentage(10)"
                            >
                                <span>+ 10%</span>
                            </b-button>
                            <b-button 
                                class="container btn-add-percentage"
                                @click="addPercentage(25)"
                            >
                                <span>+ 25%</span>
                            </b-button>
                            <b-button 
                                class="container btn-add-percentage"
                                @click="addPercentage(50)"
                            >
                                <span>+ 50%</span>
                            </b-button>
                            <b-button 
                                class="container btn-add-percentage"
                                @click="addPercentage(75)"
                            >
                                <span>+ 75%</span>
                            </b-button>
                            <b-button 
                                class="container btn-add-percentage mr-0"
                                @click="addPercentage(100)"
                            >
                                <span>+ 100%</span>
                            </b-button>
                        </b-col>
                    </div>
                    <div class="block-invisible d-none d-sm-block"/>
                </div>
            </b-form-group>
        </b-row>
    </b-form>
</template>

<script>

import {
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue';
import MinusIcon from '@/assets/images/pages/less-icon.svg';
import PlusIcon from '@/assets/images/pages/add-icon.svg';

    export default {
        components:{
            BRow,
            BCol,
            BButton,
            BForm,
            BFormGroup,
            BFormInput,
            MinusIcon,
            PlusIcon
        },
        props: ["valueInputProgress"],
        data() {
            return{
                inputProgress: null,
                keyRenderInput: 0,
                click: false
            }
        },
        methods:{
            atualizaEventClick(){
                this.click = true
            },
            filterInput(event){
                if(this.click){
                    this.inputProgress = 0
                    this.$emit("atualizaProgress", this.inputProgress); 
                    this.click = false
                }
                let input = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                let keyPressed = event.key;
                let keyCode = (event.keyCode ? event.keyCode : event.which);

                if (!input.includes(keyPressed) && (keyCode != 8)) {
                    event.preventDefault()
                }
            },
            updateProgressInput(){
                this.$emit("atualizaProgress", this.inputProgress);      
            },
            checkInput(event){
                let number = Number(event);
                 if(number > 100 ) {
                    this.inputProgress = 100;
                    this.keyRenderInput++;
                } else if (0 <= number <= 100){
                    this.inputProgress = number;
                } else {
                    this.inputProgress = 0;
                }
            },
            addPercentage(percentage){
                this.checkInputNull();
                let sum = percentage + this.inputProgress;
                if(sum < 100){
                    this.inputProgress = sum;
                } else {
                    this.inputProgress = 100;
                }
            },
            incrementPercentage(){
                this.checkInputNull();
                if(this.inputProgress < 100){
                    this.inputProgress++;
                }
            },
            decrementPercentage(){
                this.checkInputNull();
                if(this.inputProgress > 0){
                    this.inputProgress--;
                }
            },
            checkInputNull(){
                if(this.inputProgress == null){
                    this.inputProgress = 0;
                }
            }
        },
        created() {
            this.inputProgress = this.valueInputProgress;
        },
        watch: {
            inputProgress(v){
                if(v != null){
                    this.updateProgressInput();
                }
            }
        }

    }
</script>
<style lang="scss">
    .btn-input-progress{
        padding: 12px;
        min-width: 38px;
        height: 38px;
        background: #974900 !important;
        border-radius: 5px;
        border: none;
        &:focus{
            background: #974900 !important;
        }
    }
    .block-invisible{
        background: transparent;
        min-width: 28px;
        height: 28px;
    }
    .btn-add-percentage{
        margin: 0 4px !important;
        // padding: 9px 70px;
        border: 1px solid #974900 !important;
        background-color: #fff !important;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #974900 !important;
            letter-spacing: 0.0125em;
        }
        &:focus{
            background: none !important;
        }
    }
    .container-btns-add-percentage{
        margin: 0 6px !important;
        overflow-x: scroll;
        &::-webkit-scrollbar{
            display: none;
        }
    }
    .container-input-field-progress { 
        &.buttons{
            min-width: 1000px;
        } 
        min-width: 1% !important;
        display: flex;
        justify-content: center;
        span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 26px;
            color: #CFC4BE;
        }
    }
    .input-field-progress{
        background: transparent;
        color: transparent;
        z-index: 2 !important;
        position: absolute;
        &:focus{
            color:transparent;
            background: transparent;
        }
        &::placeholder{
            color:transparent;
        }
    }
    .input-div{
        min-width: 100%;
        min-height: 100%;
        position: absolute;
        top: 2.4px;
        background: transparent;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.45;
        color: #6e6b7b;
        z-index: 1 !important;
    }


@media (min-width: 481px) and (max-width: 1024px )  {
    .btn-add-percentage{
        padding: 20px 23px;
        span{
            font-size: 20px !important;
            line-height: 23px !important;
        }
    }
    .buttons-plus{
        overflow: scroll;
        &::-webkit-scrollbar{
            display: none;
        }
    }
    .container-input-field-progress {  
         &.buttons{
            min-width: 657px !important;
            overflow: scroll;
        } 
        &.input{
            height: 60px;
        
            .input-field-progress{
                height: 60px;
            }
        }
        span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 26px;
            line-height: 36px;
            color: #CFC4BE;
        }
    }
    .container-input-progress{
        .col-input-buttons{
            align-items: center !important  ;
        }
        .btn-input-progress{
            width: 46px;
            height: 46px;
        }
    }
    .container-btns-add-percentage{
        margin: 0 12px !important;
        
    }

}
@media (max-width: 480px) {
    .btn-add-percentage{
            padding: 4px 20px;
        span{
            font-weight: 600 !important;
            font-size: 12px !important;
            line-height: 20px !important;
            width: 40px;
        }
    }
}
</style>
